import React, { useState, useEffect } from "react";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import Dashboard from "../components/MerchantDashboard";
import CustomHelmet from "../components/CustomHelmet";
import CustomerReview from "../components/CustomerReview";
import axios from "axios";

const urlReview =
  "https://www.hubsquares.com/php_files/fetchReview.php/";
const Reviews = (props) => {
  const [review, setReview] = useState([]);
  useEffect(() => {
    axios
      .post(urlReview, { refID: props.match.params.ref })
      .then((res) => setReview(res.data.reviews));
  }, [props.match.params.ref]);
  return (
    <>
      <CustomHelmet page="My Business" />
      <Dashboard
        user={props.user}
        page={`My Reviews | ${props.match.params.business}`}
      >
        <Container className="my-3">
          <Link className="nav-link" to={`/reviews`}>
            <button className="addbtn btn btn-danger">
              <i className="fa fa-arrow-left px-4 fs-24" />
            </button>
          </Link>
          {review ? (
            review.map((r) => (
              <div key={r.email}>
                <CustomerReview
                  email={r.email}
                  review={r.comment}
                  rating={r.rating}
                />
              </div>
            ))
          ) : (
            <h5>No review yet</h5>
          )}
        </Container>
      </Dashboard>
    </>
  );
};
export default Reviews;
